export function getIsLastEvent(events, event) {
    return events[events.length - 1]?.seq === event.seq;
}
//# sourceMappingURL=getIsLastEvent.js.map